"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Todo',
  directives: {
    focus(el, {
      value
    }, {
      context
    }) {
      if (value) {
        context.$nextTick(() => {
          el.focus();
        });
      }
    }
  },
  props: {
    todo: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      editing: false
    };
  },
  methods: {
    deleteTodo(todo) {
      this.$emit('deleteTodo', todo);
    },
    editTodo({
      todo,
      value
    }) {
      this.$emit('editTodo', {
        todo,
        value
      });
    },
    toggleTodo(todo) {
      this.$emit('toggleTodo', todo);
    },
    doneEdit(e) {
      const value = e.target.value.trim();
      const {
        todo
      } = this;
      if (!value) {
        this.deleteTodo({
          todo
        });
      } else if (this.editing) {
        this.editTodo({
          todo,
          value
        });
        this.editing = false;
      }
    },
    cancelEdit(e) {
      e.target.value = this.todo.text;
      this.editing = false;
    }
  }
};